// import { initializeApp } from "firebase/app";
// import { getDatabase } from "firebase/database";
 

// const firebaseConfig = {
//   apiKey: "AIzaSyCMqnt1NWyn6xWR13nicrqjxKynTs3AY6c",
//   authDomain: "rps-12.firebaseapp.com",
//   databaseURL: "https://rps-12-default-rtdb.firebaseio.com",
//   projectId: "rps-12",
//   storageBucket: "rps-12.firebasestorage.app",
//   messagingSenderId: "257925398824",
//   appId: "1:257925398824:web:9e4d52aeed2a4fc6ea501d"
// };


// const app = initializeApp(firebaseConfig);
// export const db = getDatabase(app);

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:       process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);